import React from "react";
import { Button, Popup } from "semantic-ui-react";

const MenuControlButton = ({
	icon,
	onClick,
	message,
	left = false,
	...rest
}) => (
	<Popup
		content={message}
		inverted
		position={`${left ? "left" : "right"} center`}
		size="tiny"
		trigger={
			<Button
				basic
				circular
				compact
				icon={icon}
				onClick={onClick}
				size="tiny"
				{...rest}
			/>
		}
	/>
);

export default MenuControlButton;
